<template>
    <li v-if="shouldRenderItem" :class="{
        'active': isActive,
    }">
        <router-link :to="href" v-if="isVuePage" @click.native="hideSidebarMenuOnMobile">
            <i v-if="Boolean(icon)" :class="`fa fa-${icon}`" /> {{ label }}
        </router-link>
        <a :href="href" v-else>
            <i v-if="Boolean(icon)" :class="`fa fa-${icon}`" /> {{ label }}
        </a>
    </li>
</template>

<script>
import PermissionMixin from '../mixins/PermissionMixin'
import SidebarMenuMixin from '../mixins/SidebarMenuMixin'

export default {
    computed: {
        isVuePage() {
            return $('meta[name="is_vue_page"]').attr('content') == 1
        },
    },
    methods: {
        hideSidebarMenuOnMobile() {
            $('body').removeClass('sidebar-open')
        },
    },
    mixins: [
        PermissionMixin,
        SidebarMenuMixin,
    ],
    props: {
        activePaths: {
            type: Array,
            required: false,
            default: () => [],
        },
        href: {
            type: String,
            required: false,
            default: null,
        },
        permissions: {
            type: Array,
            required: false,
            default: null,
        },
    }
}
</script>